import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

// Contact details stay empty until the store owner provides them.
// Every empty field is simply hidden on the site.
export const siteConfig: SiteConfig = {
    name: 'آهنین',
    tagline: 'میز، صندلی و منقل فلزی',
    description: 'فروشگاه اینترنتی آهنین برای خرید میز، صندلی، منقل و باربیکیوی فلزی با ساخت محکم، رنگ کوره‌ای و ارسال به سراسر کشور.',
    url: getOrigin(),
    ogImage: 'https://ahanin.cdn.modulify.website/images/charcoal-grill.jpg',
    contact: {
        phone: '',
        whatsapp: '',
        instagram: '',
        address: '',
        hours: ''
    }
}

export const CART_STORAGE_KEY = 'ahanin-cart-v1'

export const MAX_ITEM_QUANTITY = 20

export const ORDER_STATUS_DEFAULT = 'در انتظار تماس'

export const IRAN_PROVINCES = [
    'آذربایجان شرقی',
    'آذربایجان غربی',
    'اردبیل',
    'اصفهان',
    'البرز',
    'ایلام',
    'بوشهر',
    'تهران',
    'چهارمحال و بختیاری',
    'خراسان جنوبی',
    'خراسان رضوی',
    'خراسان شمالی',
    'خوزستان',
    'زنجان',
    'سمنان',
    'سیستان و بلوچستان',
    'فارس',
    'قزوین',
    'قم',
    'کردستان',
    'کرمان',
    'کرمانشاه',
    'کهگیلویه و بویراحمد',
    'گلستان',
    'گیلان',
    'لرستان',
    'مازندران',
    'مرکزی',
    'هرمزگان',
    'همدان',
    'یزد'
]

export const CONTACT_SUBJECTS = [
    'سوال درباره‌ی محصول',
    'سفارش در ابعاد یا رنگ دیگر',
    'پیگیری سفارش',
    'همکاری و خرید عمده',
    'سایر موارد'
]
